<template>
	<DashboardView :isPreview="false" :isMobileDevice="isMobileDevice"/>
</template>

<script >
import DashboardView from '@views/DashboardView.vue'
import { startUpdateData, startUpdateResource, startUpdateActiveDashboard, startUpdateDashboard, startUpdateDashboardForGroup } from "../state/dashboard-state"
export default {
	inject: [ 'keycloakState', 'dashboardState','updtInterval' ],
	components: {
		DashboardView
	},
	props: {
		isPreview: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	methods: {
		startDataAndResourceUpdate() {
			this.updateDataIntervalId = startUpdateData(this.updtInterval.dataInterval)
			this.updateResourceIntervalId = startUpdateResource(this.updtInterval.resourceInterval)
		},
		startActiveDashboardUpdate() {
			this.updateActiveIntervalId = startUpdateActiveDashboard(this.updtInterval.activeDashboardInterval)
		},
		startDashboardUpdateForGroup(groupId) {
			this.updateActiveIntervalId = startUpdateDashboardForGroup(this.updtInterval.activeDashboardInterval, groupId)
		},		
		startDashboardUpdate(dashboardId) {
			this.updateActiveIntervalId = startUpdateDashboard(this.updtInterval.activeDashboardInterval, dashboardId)
		},			
		stopUpdateData() {
			if (this.updateDataIntervalId) {
				clearInterval(this.updateDataIntervalId)
				this.updateDataIntervalId = null
			}
		},

		stopUpdateResource() {
			if (this.updateResourceIntervalId) {
				clearInterval(this.updateResourceIntervalId)
				this.updateResourceIntervalId = null
			}
		},
		stopUpdateActive() {
			if (this.updateActiveIntervalId) {
				clearInterval(this.updateActiveIntervalId)
				this.updateActiveIntervalId = null
			}
		},
		checkIfMobileDevice() {
            this.isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        }
	},
	mounted() {
		this.checkIfMobileDevice()
        window.addEventListener('resize', this.checkIfMobileDevice)
		const routePath = this.$route.path
		const groupId = this.$route.params.groupId
		const dashboardId = this.$route.params.id

		if (routePath === '/dashboard/active') {
			this.dashboardState.loadPublicDashboard()
			this.startActiveDashboardUpdate()
		} else if (routePath.startsWith('/dashboard/active/') && groupId) {
			this.dashboardState.loadPublicDashboard(groupId)
			this.startDashboardUpdateForGroup(groupId)
		} else if (routePath.startsWith('/dashboard/dashboard/') && dashboardId) {
			this.dashboardState.loadDashboardById(dashboardId)
			this.startDashboardUpdate(dashboardId)
		} else if (routePath.startsWith('/admin/dashboard/') && dashboardId) {
			this.dashboardState.loadDashboard(dashboardId, false)
			this.startDataAndResourceUpdate()
		} else {
			this.dashboardState.loadPublicDashboard()
			this.startActiveDashboardUpdate()
		}
	},
	beforeUnmount() {
		this.stopUpdateData()
		this.stopUpdateResource()
		window.removeEventListener('resize', this.checkIfMobileDevice)
	},

	data() {
		return {
			updateDataIntervalId: null,
			updateResourceIntervalId: null,
			updateActiveIntervalId: null,
			isMobileDevice: window.innerWidth <= 600
		}
	}
}

</script>

<style scoped lang="scss"></style>